// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yIC8m","importantInfo":"styles_importantInfo__2mifM"};